/**
 * Date Services.
 * @format
 */

/**
 * Check if date is before current date
 */
export const isPastDate = (date: string) => {
  const newDate = new Date(date);
  if (Number.isNaN(newDate.getTime())) {
    return false;
  }
  const todaysDate = new Date();
  const milliseconds = newDate.valueOf() - todaysDate.valueOf();
  const hours = Math.ceil(milliseconds / (1000 * 3600));
  return hours <= -23;
};

/**
 * Removes date range if start and end date are the same
 */
export const removeRangeIfStartAndEndDatesAreSame = (date: string) => {
  const [dateStart, dateEnd] = date.split(' - ');
  if (dateStart === dateEnd) {
    return dateStart;
  }
  return date;
};

/**
 * Converts drupal field date format string to date object.
 */
export const getDrupalDateTime = (
  drupalDateTimeFormat: string | null | undefined
): Date | null => {
  if (drupalDateTimeFormat) {
    const dateAndTimeArray = drupalDateTimeFormat?.split(',')[1]?.split(' - ');
    let safeDateTime = ``;
    if (dateAndTimeArray && dateAndTimeArray.length > 0) {
      const endDate = dateAndTimeArray[0].replace(/\s/g, '').split('/');
      safeDateTime = `${endDate[2]}-${endDate[0]}-${endDate[1]}T${dateAndTimeArray[1]}`;
      return new Date(safeDateTime);
    }
  }
  return null;
};
